/* =========================================================================
 * WHICH BUILD IS THIS? One answer, readable at a glance.
 *
 * Brian, 2026-09-18: "we are still showing v2.50". He was right to be unsure.
 * The version came from package.json alone, the bundle live BEFORE the
 * 2026-09-17 deploy already read 2.50.0, and so did the one after it. A
 * version string somebody has to remember to bump cannot tell two builds
 * apart when nobody bumped it, which is exactly when the question gets asked.
 *
 * So the label carries three things, and two of them cannot be forgotten:
 *
 *   version  package.json. Still the release number (hard rule 6).
 *   commit   `git rev-parse --short HEAD` at BUILD time (vite.config.js). A
 *            new commit is a new label with nobody remembering anything, and
 *            a build from uncommitted source says so ("+local").
 *   bundle   the hashed entry file THIS PAGE IS RUNNING, read at runtime from
 *            import.meta.url. It is the same name the deploy is verified by,
 *            so "is what I am looking at the thing you deployed" is answered
 *            by reading it off the footer against the name in the report.
 *
 * builtAt rides in the tooltip. The bundle name is the strongest of the four:
 * it is not what the build claims about itself, it is what the browser
 * actually loaded.
 * ========================================================================= */

const injected = typeof __BUILD_INFO__ !== 'undefined' ? __BUILD_INFO__ : null

function bundleName() {
  try {
    const m = /\/assets\/(index-[\w-]+\.js)/.exec(String(import.meta.url))
    return m ? m[1] : 'dev'
  } catch {
    return 'unknown'
  }
}

export const BUILD = Object.freeze({
  version: injected?.version || (typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0'),
  releaseVersion: injected?.releaseVersion || (typeof __APP_RELEASE_VERSION__ !== 'undefined' ? __APP_RELEASE_VERSION__ : null),
  commit: injected?.commit || 'unknown',
  dirty: !!injected?.dirty,
  builtAt: injected?.builtAt || '',
  bundle: bundleName(),
})

export function displayVersion(b = BUILD) { return b.releaseVersion || `v${b.version}` }

/** "v2.51.0 · 5ae34fe" (or "5ae34fe+local" when built from uncommitted source). */
export function buildLabel(b = BUILD) {
  return `${displayVersion(b)} · ${b.commit}${b.dirty ? '+local' : ''}`
}

/** Short, local build time for the pill: "Sep 18, 2:04 PM". */
export function builtAtShort(b = BUILD) {
  if (!b.builtAt) return ''
  const d = new Date(b.builtAt)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
}

/** Everything, for the tooltip and for anyone asking from the console. */
export function buildDetail(b = BUILD) {
  return [
    `Release ${displayVersion(b)}`,
    `Package version ${b.version}`,
    `Commit ${b.commit}${b.dirty ? ' (built with uncommitted changes)' : ''}`,
    `Bundle ${b.bundle}`,
    b.builtAt ? `Built ${b.builtAt}` : '',
  ].filter(Boolean).join('\n')
}

// Readable from DevTools without hunting through a minified bundle.
if (typeof window !== 'undefined') window.__SR_BUILD__ = BUILD
